<template>
  <div class="page-content">
    <div class="login-b">
      <el-card class="box-card">
        <div class="header-login">用户登录</div>
        <el-input placeholder="用户名" v-model="username">
          <template slot="append"><i class="el-icon-user"></i></template>
        </el-input>
        <el-input placeholder="密码" v-model="password" type="password" style="margin-top: 20px;">
          <template slot="append"><i class="el-icon-lock"></i></template>
        </el-input>

        <el-input placeholder="验证码" v-model="code" style="margin-top: 20px;">
          <!-- <template slot="prepend"><i class="el-icon-view"></i></template> -->
          <template slot="append">
            <verify-code :identifyCode="verify_code" @getCode="getCode()" style="position: absolute; right: 0; top: 0;"></verify-code>
          </template>
        </el-input>
        <!-- <el-input placeholder="请输入密码" v-model="password" show-password></el-input> -->
        <el-button type="primary" @click="login" style="width: 100%; margin-top: 20px;">登录</el-button>
      </el-card>
      <div class="font-d">
        <p>新华网是全球网民了解中国的最重要窗口</p>
        <p>致力于为全球网民提供最权威最及时的新闻信息服务</p>
        <p>目前桌面端日均页面浏览量超过1.6亿</p>
        <p>移动端日均覆盖人群超过3.4亿</p>
      </div>
    </div>
    <div class="font-b">
      <p>新华社主办 版权所有：新华网股份有限公司 Copyright © 2000-2020 XINHUANET.com All Rights Reserved.</p>
      <p>本站所刊登的新华社及新华网各种新闻﹑信息和各种专题专栏资料，均为新华网版权所有，未经协议授权禁止下载使用。</p>
      <p style="position: relative;"><img src="../../assets/images/C4.png">京公网安备：11000002000015号 | 网上传播视听节目许可证(0103020) | 中国互联网视听节目服务自律公约 | 可信网站认证<img src="../../assets/images/C3.png" class="c3"></p>
    </div>
  </div>
</template>
<script>
export default {
  /* global require */
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      code: '',
      verify_code: ''
    };
  },
  created() {
    if (sessionStorage.getItem('token')) {
      this.$router.push({ path: '/' });
    }
    this.getCode();
  },
  beforeCreate() {
    if (this.$route.query.token) {
      this.$http.post('/trader/login/login', {
        token: this.$route.query.token
      }).then(res => {
        if (res.code === 200) {
          window.location.href = this.$Config.apiUrl;
        } else {
          this.$router.push({ path: '/login' });
        }
      });
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    getCode() {
      const str = '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKMNOPQRSTUVWXYZ';
      const codes = str.split('');
      const arr = [];
      for (let i = 0; i < 4; i++) { // 从0-61之间取随机数
        const index = Math.floor(Math.random() * (58 - 0 + 1) + 0);
        const char = codes[index];
        arr.push(char);
      }
      this.verify_code = arr.join('');
    },
    login() {
      if (this.username === '') {
        this.$message.error('用户名不能为空');
        return false;
      }
      if (this.password === '') {
        this.$message.error('密码不能为空');
        return false;
      }
      if (this.code === '') {
        this.$message.error('验证码不能为空');
        return false;
      }
      if (this.code.toLowerCase() !== this.verify_code.toLowerCase()) {
        this.$message.error('验证码有误');
        this.getCode();
        return false;
      }
      this.$http.post('/trader/login/doLogin', {
        username: this.username,
        password: this.password
      })
        .then(res => {
          if (res.code === 200) {
            this.$router.push({ path: '/' });
          } else {
            this.$message.error(res.msg);
          }
        });
    }
  },
  components: { VerifyCode: resolve => require(['./Components/VerifyCode.vue'], resolve) }
};
</script>
<style lang="less">
  html, body, #app {
    padding: 0;
    margin: 0;
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    width: 100%;
    height: 100%;
  }
  .page-content {
    width: 100%;
    height: 100%;
    background: url(../../assets/images/login-bg.png) no-repeat;
    background-size: 100% 100%;
    position: relative;
    .login-b {
      width: 380px;
      position: absolute;
      top: 15vh;
      right: 5vh;
    }
    .box-card {
      width: 280px;
      height: 320px;
      margin-top: 30px;
      margin-left: 50px;
      border-radius: 15px;
      .header-login {
        width: 100%;
        height: 60px;
        text-align: center;
        color: #166D9F;
        font-size: 24px;
        font-weight: bold;
      }
    }
    .font-d {
      color: #B5EAFF;
      font-size: 14px;
      width: 380px;
      text-align: center;
      margin-top: 20px;
      p {
        margin-top: 10px;
      }
    }
    .font-b {
      width: 100%;
      color: #fff;
      font-size: 12px;
      text-align: center;
      position: absolute;
      bottom: 2vh;
      img {
        width: 12px;
        height: 13px;
        margin-right: 5px;
      }
      .c3 {
        width: 25px;
        height: auto;
        position: absolute;
        bottom: 0;
        margin-left: 20px;
      }
      p {
        margin-top: 0px;
      }
    }
  }
  .el-card__body {
    padding: 20px;
  }
  .el-input-group__append {

  }
</style>
